<ng-container *ngIf="loaded; else loader">
  <ul *ngIf="data.length > 0; else emptyHistory">
    <li *ngFor="let entry of data; let i = index; let l = last; let f = first">
      <div class="major-info">
        <ng-container *ngTemplateOutlet="major; context: { data: entry, index: i, first: f, last: l }"></ng-container>
      </div>
      <div class="minor-info">
        <ng-container *ngTemplateOutlet="minor; context: { data: entry, index: i, first: f, last: l }"></ng-container>
      </div>
    </li>
  </ul>
</ng-container>

<ng-template #loader>
  <app-loader></app-loader>
</ng-template>

<ng-template #emptyHistory>
  <div class="history-empty">{{ empty }}</div>
</ng-template>
